import React from 'react';

// instead of passing just props and then using props.video, 
// you can just put it in ES6 brackets and declare just video so you dont have to us the 
// .notation in the code below and save space
const VideoListItem = ({video, onVideoSelect}) => {
	const imageUrl = video.snippet.thumbnails.default.url;

	return (
		<li onClick={() => onVideoSelect(video)} className="list-group-item" >
			<div className="video-list media">
				<div className="media-left">
					<img className="media-object" src={imageUrl}/>
				</div>

				<div className="media-body">
					<div className="media-heading">{ video.snippet.title }</div>
				</div>
			</div>
		</li>
	);
};

export default VideoListItem;


// WEBPACK FOOTER //
// ./src/components/video_list_item.js